import React, { useContext } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { OnboardingContext } from 'providers/OnboardingContext';
import { BsQuestion } from 'react-icons/bs';

import './styles.scss';

import { ampli } from '@/ampli';

interface OnboardingButtonProps {
  onClick?: () => void;
}

const OnboardingButton: React.FC<OnboardingButtonProps> = ({ onClick }) => {
  const { startOnboarding } = useContext(OnboardingContext);

  return (
    <Tooltip title="Ayúdame a entender esta pantalla" placement="left">
      <div className="onboarding-fab-button">
        <Fab
          color="secondary"
          aria-label="help"
          onClick={() => {
            ampli.onboardingModalViewed({
              'onboarding screen path': window.location.pathname,
              'onboarding type': 'button',
            });
            onClick && onClick();
            startOnboarding();
          }}
          sx={{
            width: '40px',
            height: '40px',
            boxShadow: 'none',
          }}
        >
          <BsQuestion size="24" />
        </Fab>
      </div>
    </Tooltip>
  );
};

export default OnboardingButton;
